// extracted by mini-css-extract-plugin
export default {"modalOverlay":"xE-z","modalContent":"yE-z","header":"zE-z","close":"AE-z"};